import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";

import { AppMemoryService } from "./../../core/app-memory.service";
import { GetService } from "app/core/get.service";
import { NotificationsService } from "angular2-notifications";
import { AuthService } from "./../../auth/auth.service";
import { Router, ActivatedRoute } from "@angular/router";
import { TooltipComponent } from "../../core/tooltip/tooltip.component";
import { environment } from "environments/environment";

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.less"],
  host: { class: "nav-main" },
})
export class NavComponent implements OnInit {
  public currentWidth: number | undefined;
  public showSubMenu = false;
  public isShowTooltip: boolean = false;
  public isShowTutorial: boolean = false;
  @ViewChild("addHorseTutorial") addHorseTutorial: TooltipComponent;
  @ViewChild("addTreatmentTutorial") addTreatmentTutorial: TooltipComponent;

  public currentCountry = environment.currentCountry;
  public isUkCountry = this.currentCountry.toLowerCase() === "uk";
  public isIECountry = this.currentCountry.toLowerCase() === "ie";
  public isUSCountry = this.currentCountry.toLowerCase() === "us";

  constructor(
    public appMemory: AppMemoryService,
    public getService: GetService,
    public authService: AuthService,
    public router: Router,
    public changeDetectorRef: ChangeDetectorRef
  ) {
    this.isShowTooltip = this.appMemory.getTooltip();
    this.isShowTutorial = this.appMemory.getTutorial();
  }

  ngOnInit() {
    this.resizedWindow(window);
  }

  setTooltip() {
    this.appMemory.setTooltip((this.isShowTooltip = !this.isShowTooltip));
  }

  setTutorial() {
    this.getService.showTutorial = true;
    this.appMemory.setTutorial((this.isShowTutorial = !this.isShowTutorial));
  }

  logout() {
    this.router.navigate(["login"], {});
    this.getService.logOut().then(
      (res: any) => {
        // console.log(res);
      },
      (err: any) => {
        // console.log(err);
      }
    );

    this.authService.logout();
  }

  showTooltip(key, localClass) {
    switch (key) {
      case "add-horse": {
        return this.addHorseTutorial.showTooltip(key, localClass);
      }
      case "add-treatment": {
        console.log("add-treatment nav");
        return this.addTreatmentTutorial.showTooltip(key, localClass);
      }
    }
    // return this.tooltip.showTooltip(key);
  }

  @HostListener("window:resize", ["$event.currentTarget"])
  resizedWindow(event) {
    this.currentWidth = event.innerWidth;
  }

  showChild(event) {
    if (this.currentWidth > 767) {
      event.srcElement.children[1].style.top = `${
        event.srcElement.getBoundingClientRect().top
      }px`;
    }
  }

  showNestedOnClick() {
    if (this.currentWidth < 768) {
      this.showSubMenu = !this.showSubMenu;
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/nav/nav.component.ts